import { useQuery, useMutation } from "@tanstack/react-query";
import api from "../../services/api";
import { useQueryClient } from "@tanstack/react-query";
import Swal from "sweetalert2";

export default function Settings() {
  const queryClient = useQueryClient();

  const { data: response, isLoading } = useQuery({
    queryKey: ["settings"],
    queryFn: () => api.get("/settings").then(res => res.data),
  });

  const settings = response?.settings || {};

  const mutation = useMutation({
    mutationFn: (data) => api.put("/settings", { settings: data }),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: ["settings"] });
      Swal.fire({
        icon: "success",
        title: "Settings Updated!",
        text: "Your settings have been saved successfully.",
        confirmButtonColor: "#6366f1",
        timer: 2000,
        showConfirmButton: true,
      });
    },
  });

  const submit = (e) => {
    e.preventDefault();
    const formData = {
      min_review_rating: e.target.min_review_rating.value,
    };

    mutation.mutate(formData);
  };

  if (isLoading) return (
    <div className="text-center py-12 text-gray-600">
      Loading settings<span className="animate-pulse">...</span>
    </div>
  );

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 mb-6">
      <div className="flex justify-between items-center mb-6 pb-6 border-b border-gray-200">
        <h2 className="text-2xl font-bold text-gray-900">Settings</h2>
      </div>

      <div className="max-w-2xl">
        {mutation.isError && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm mb-6">
            {mutation.error?.response?.data?.message || "Something went wrong. Please try again."}
          </div>
        )}

        {mutation.isSuccess && mutation.data?.data?.updated && (
          <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm mb-6">
            Settings updated successfully!
          </div>
        )}

        <form onSubmit={submit} className="space-y-6">
          <div className="space-y-2">
            <label htmlFor="min_review_rating" className="block text-sm font-semibold text-gray-700">
              Minimum Review Rating for Amazon Redirect
            </label>
            <input
              id="min_review_rating"
              name="min_review_rating"
              type="number"
              min="1"
              max="5"
              defaultValue={settings?.min_review_rating || "4"}
              required
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/10 transition-all"
            />
            <p className="text-sm text-gray-600 mt-2">
              Users with a rating &gt;= this value will be redirected to Amazon after submitting their review.
              Lower values mean more users get redirected.
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <button
              type="submit"
              className="bg-gradient-to-r from-primary to-secondary text-white py-3 px-6 rounded-lg font-semibold shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none"
              disabled={mutation.isPending}
            >
              {mutation.isPending ? "Saving..." : "Save Settings"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
